const LegalMentions = () => {
  return (
    <div data-testid="legal-page">
      <section className="page-header">
        <div className="page-container">
          <h1 className="page-title">Mentions légales</h1>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="page-container">
          <div className="max-w-3xl prose prose-neutral">
            <h2 className="text-xl font-heading mt-8 mb-4">Éditeur du site</h2>
            <p className="text-muted-foreground mb-4">
              Ce site est édité par Nymphea, artiste tatoueuse.<br />
              Atelier La Peauésie<br />
              9 quai Ernest de Franqueville<br />
              85100 Les Sables-d'Olonne, France
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Hébergement</h2>
            <p className="text-muted-foreground mb-4">
              Ce site est hébergé par Emergent.<br />
              Les données sont stockées de manière sécurisée.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Propriété intellectuelle</h2>
            <p className="text-muted-foreground mb-4">
              L'ensemble du contenu de ce site (textes, images, designs, logos) est protégé par le droit d'auteur. 
              Toute reproduction, même partielle, est interdite sans autorisation préalable.
            </p>
            <p className="text-muted-foreground mb-4">
              Les photographies des tatouages présentées sur ce site sont la propriété exclusive de Nymphea. 
              Elles ne peuvent être utilisées à des fins commerciales ou reproduites sans accord écrit.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Responsabilité</h2>
            <p className="text-muted-foreground mb-4">
              Nymphea s'efforce de fournir sur ce site des informations aussi précises que possible. 
              Toutefois, elle ne pourra être tenue responsable des omissions, inexactitudes ou carences 
              dans la mise à jour de ces informations.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Données personnelles</h2>
            <p className="text-muted-foreground mb-4">
              Les informations collectées via les formulaires de ce site sont destinées uniquement à 
              la gestion des demandes de projets, rendez-vous et commandes. Elles ne sont en aucun cas 
              cédées à des tiers.
            </p>
            <p className="text-muted-foreground mb-4">
              Conformément à la loi « Informatique et Libertés » et au RGPD, vous disposez d'un droit 
              d'accès, de rectification et de suppression de vos données personnelles.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Cookies</h2>
            <p className="text-muted-foreground mb-4">
              Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. 
              Aucun cookie publicitaire ou de tracking n'est utilisé.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalMentions;
